// A leafy shrub: a small clump of faceted icosahedron blobs. Ported 1:1 from
// age-of-mcp's classic bush.ts.
import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

function partsFor(): Part[] {
  return [
    { geometry: new THREE.IcosahedronGeometry(0.12, 0),
      color: "#346a2c", position: [-0.065, 0.1, 0.022] },
    { geometry: new THREE.IcosahedronGeometry(0.1, 0),
      color: "#3e7d36", position: [0.075, 0.082, -0.028] },
    { geometry: new THREE.IcosahedronGeometry(0.11, 0),
      color: "#4f9a3d", position: [0.01, 0.155, 0.045] },
    { geometry: new THREE.IcosahedronGeometry(0.055, 0),
      color: "#7ec575", position: [-0.045, 0.2, 0] },
  ];
}

export const bush = defineModel({
  id: "bush",
  batchId: "standard",
  name: "Bush",
  tags: ["scenery","bush","low-poly","age-of-mcp","classic"],
  summary: "Low-poly bush.",
  description: "Ported from the age-of-mcp gallery.",
  author: "age-of-mcp",
  footprint: 0.2,
  parts: () => partsFor(),
  animations: [],
});
